<div class="ss-g-menuP layout-menuitem ">
    <div class="cardSaldoMenu h-full relative" style="overflow: visible;border-radius: 12px;">

        <svg id="visual" viewBox="0 0 900 600" xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" preserveAspectRatio="none"
            class="absolute left-0 top-0 h-full w-full z-1" style="border-radius: 12px;">
            <rect x="0" y="0" width="900" height="600" fill="var(--primary-600)"></rect>
            <path
                d="M0 400L30 386.5C60 373 120 346 180 334.8C240 323.7 300 328.3 360 345.2C420 362 480 391 540 392C600 393 660 366 720 355.2C780 344.3 840 349.7 870 352.3L900 355L900 601L870 601C840 601 780 601 720 601C660 601 600 601 540 601C480 601 420 601 360 601C300 601 240 601 180 601C120 601 60 601 30 601L0 601Z"
                fill="var(--primary-500)" stroke-linecap="round" stroke-linejoin="miter"></path>
        </svg>
    </div>
</div>
<style>
    .layout-menu {
        width: 100%;
        /* Assegura que o menu ocupe a largura total do contêiner */
    }

    .layout-menu li {
        width: 100%;
        /* Assegura que cada item do menu ocupe a largura total */
        text-align: left;
        /* Alinha o texto à esquerda */
    }

    .menu-separator {
        width: 100%;
        /* Garante que os separadores ocupem a largura total */
    }

    .divMenu {
        width: 100%;
        /* Garante que os divisores dentro dos separadores ocupem a largura total */
    }

    .flex-container {
        display: flex;
        flex-direction: column;
        height: 100%;
    }

    .s-s-l-menuSidebar {
        height: 100%;
    }

    .flex-spacer {
        flex-grow: 1;
    }

    .sidebar-header .player-button {
        width: 100%;
        /* Assegura que cada item do menu ocupe a largura total */
        text-align: left;
    }

    ::ng-deep .layout-container.layout-sidebar-active .layout-sidebar .layout-menu ul a span {
        font-weight: 600;
    }

    ::ng-deep .ss-l-text-menu {
        font-family: 'Roboto', sans-serif;
        font-weight: 800;
    }

    /* cada opção ocupa 50% e centraliza o conteúdo */
    /* .menu-theme{
        position: absolute;
        bottom: 40px;
    } */
    :host ::ng-deep .menu-theme .p-selectbutton.p-buttonset {
        display: flex;
        width: 100%;
    }

    /* cada opção divide igualmente */
    :host ::ng-deep .menu-theme .p-selectbutton .p-button {
        flex: 1 1 50%;
        justify-content: center;
        min-width: 0;
    }

    /* quando o Prime marca como "icon-only", removemos a largura fixa */
    :host ::ng-deep .menu-theme .p-selectbutton .p-button.p-button-icon-only {
        width: auto !important;
        flex: 1 1 50% !important;
        padding: 0.25rem 0 !important;
    }
</style>
<div class="s-s-l-menuSidebar">
    <ul class="layout-menu flex-container mb-3">
        <ng-container *ngFor="let item of model; let i = index">
            <!-- itens normais -->
            <li app-menuitem class="ss-l-font-menu" *ngIf="!item.separator && !item.custom" [item]="item" [index]="i"
                [root]="true"></li>

            <!-- separador -->
            <li *ngIf="item.separator" class="menu-separator divMenu" [ngClass]="item.styleClass">
                <div class="divMenu p-button-label"></div>
            </li>

            <!-- bloco custom: seletor de tema -->
            <li *ngIf="item.custom === 'themeToggle'" class="menu-theme px-3 py-2">
                <!-- wrapper agora ocupa 100% -->
                <div class="w-full">
                    <ng-container *ngIf="isMobile() || layoutService.state.sidebarActive; else compactMode">
                        <p-selectButton [options]="modes" [(ngModel)]="selectedMode"
                            (ngModelChange)="onModeChange($event)" optionLabel="label" optionValue="value"
                            styleClass="p-button-sm w-full">
                            <ng-template pTemplate="item" let-option>
                                <i [class]="option.icon" class="mr-2"></i>
                                <span *ngIf="layoutService.state.sidebarActive && !isMobile()">{{ option.label }}</span>
                            </ng-template>
                        </p-selectButton>
                    </ng-container>

                    <ng-template #compactMode>
                        <button type="button" class="p-button p-button-text p-button-rounded p-button-sm shadow-none"
                            [attr.aria-label]="selectedMode === 'dark' ? 'Tema escuro' : 'Tema claro'">
                            <i class="pi" [ngClass]="selectedMode === 'dark' ? 'pi-moon' : 'pi-sun'"></i>
                        </button>
                    </ng-template>
                </div>
            </li>

        </ng-container>
    </ul>


</div>